import usePlayground from '@/modules/playground/hooks/usePlayground.hook';
import useGetCardStats from '../../hooks/useGetCardStats.hook';
import { useEffect, useState } from 'react';
import CardMetricsTable from './components/desktop/Table';
import CardMetricsList from './components/mobile/List';
import { useAnalytics } from '../../hooks/useAnalytics.hook';

const CardMetrics = () => {
  const { state } = usePlayground();
  const { dateFilter, filters } = useAnalytics();
  const getCardStats = useGetCardStats();

  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [cachedData, setCachedData] = useState(null);

  useEffect(() => {
    if (!state.payload?._id) return;

    getCardStats.mutate(
      {
        link_in_bio_id: state.payload._id,
        start_date: dateFilter.start,
        end_date: dateFilter.end,
        page,
        limit,
        ...filters,
      },
      {
        onSuccess: (data) => {
          setCachedData(data.data);
        },
      },
    );
  }, [state.payload?._id, page, limit, dateFilter, filters]);

  if (!cachedData) return null;

  return (
    <div className="border border-secondary bg-dark rounded-2xl px-4 my-6">
      <div className="flow-root">
        <div className="-mx-4 -my-4 overflow-x-auto">
          <div className="inline-block min-w-full p-4 align-middle">
            <div className="hidden md:block">
              <CardMetricsTable
                data={cachedData}
                page={page}
                limit={limit}
                setPage={setPage}
                setLimit={(newLimit) => {
                  setLimit(newLimit);
                  setPage(1);
                }}
              />
            </div>

            <div className="block md:hidden pt-4">
              <CardMetricsList
                data={cachedData}
                page={page}
                limit={limit}
                setPage={setPage}
                setLimit={(newLimit) => {
                  setLimit(newLimit);
                  setPage(1);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardMetrics;
